/* ===============================
   GLOBAL STORE-LOCATOR JS LOGIC
   (Handles store selection & cart clearing)
   =============================== */

/* ========= GUARANTEED SINGLETON PATTERN =========== */
if (!window.__SMOKEYS_STORE_LOCATOR__) {
  window.__SMOKEYS_STORE_LOCATOR__ = true;

  // ===== RS STORE DATA LOADER (single source of truth from Liquid) =====
  function loadStoresFromDom() {
    try {
      var el = document.getElementById('rs-store-data');
      if (!el) return null;
      var data = JSON.parse(el.textContent || el.innerText || '{}');
      if (!data || !Array.isArray(data.stores)) return null;
      return data;
    } catch (e) {
      console.error('[Store-Locator] Failed to parse rs-store-data JSON', e);
      return null;
    }
  }

  var RS_STORE_DATA = loadStoresFromDom();

  // ========= CENTRALIZED STORE HOURS CONFIGURATION =========
  var CLOSE_HOUR = 23; // 11pm in 24hr format
  var OPEN_HOUR = 10;  // 10am in 24hr format

  // Calculate cutoff times automatically
  // Express: 90 min before close (9:30pm for 11pm close)
  // Standard: 105 min before close (9:15pm for 11pm close)
  var expressCutoffMinutes = (CLOSE_HOUR * 60) - 90;   // 23*60 - 90  = 1290 = 9:30pm
  var standardCutoffMinutes = (CLOSE_HOUR * 60) - 105;  // 23*60 - 105 = 1275 = 9:15pm
  var expressHour = Math.floor(expressCutoffMinutes / 60);
  var standardHour = Math.floor(standardCutoffMinutes / 60);

  // Format times for display
  function formatHour(hour) {
    var suffix = hour >= 12 ? 'pm' : 'am';
    var displayHour = hour > 12 ? hour - 12 : hour;
    return displayHour + ':00' + suffix;
  }

  function formatHourLong(hour) {
    var suffix = hour >= 12 ? 'p.m.' : 'a.m.';
    var displayHour = hour > 12 ? hour - 12 : hour;
    return displayHour + ':00 ' + suffix;
  }

  function formatHourWithMinutes(hour, minutes) {
    var suffix = hour >= 12 ? 'pm' : 'am';
    var displayHour = hour > 12 ? hour - 12 : hour;
    var mins = minutes < 10 ? '0' + minutes : minutes;
    return displayHour + ':' + mins + suffix;
  }

  window.STORE_HOURS = {
    closeTime: formatHourLong(CLOSE_HOUR),
    closeTimeShort: formatHour(CLOSE_HOUR),
    openTime: formatHourLong(OPEN_HOUR),
    openTimeShort: formatHour(OPEN_HOUR),
    expressDeliveryCutoff: formatHourWithMinutes(Math.floor(expressCutoffMinutes / 60), expressCutoffMinutes % 60),
    standardDeliveryCutoff: formatHourWithMinutes(Math.floor(standardCutoffMinutes / 60), standardCutoffMinutes % 60),
    closeHour24: CLOSE_HOUR,
    openHour24: OPEN_HOUR,
    expressCutoffMinutes: expressCutoffMinutes,  // 1290 = 9:30pm in minutes from midnight
    standardCutoffMinutes: standardCutoffMinutes, // 1290 = 9:30pm in minutes from midnight
    openMinutes: OPEN_HOUR * 60  // 600 = 10:00am in minutes from midnight
  };

  // ========= MARKET IDENTIFICATION =========
  // Derive marketId from store city/province (fallback if marketId not set on store object)
  function deriveMarketId(store) {
    if (!store) return 'edmonton';
    if (store.marketId) return store.marketId;
    var city = (store.city || '').toLowerCase();
    var prov = (store.province || store.region || '').toLowerCase();
    if (prov === 'on') return 'toronto';
    if (prov === 'ab') return 'edmonton';
    // Future: if (city.includes('calgary') && prov === 'ab') return 'calgary';
    return 'edmonton';
  }
  window.deriveMarketId = deriveMarketId;

  // ========= BUILD STORES FROM CONFIG OR FALLBACK =========
  // Helper to normalize store object with consistent property names
  function normalizeStore(store) {
    var marketId = deriveMarketId(store);
    return {
      id: store.id,
      marketId: marketId,
      pickupOnly: !!store.pickupOnly,
      name: store.name,
      address: store.address || store.street,
      city: store.city,
      province: store.province || store.region,
      postalCode: store.postalCode || store.postal,
      latitude: store.latitude || store.lat,
      longitude: store.longitude || store.lng,
      isDeliveryAvailable: store.isDeliveryAvailable || false,
      isVirtualStore: !!store.isVirtualStore,
      deliveryRadius: store.deliveryRadius || 0,
      displayRadiusKmDriving: store.displayRadiusKmDriving || store.deliveryRadius || 50,
      openUntil: window.STORE_HOURS.closeTime,
      phone: store.phone,
      license: store.license
    };
  }

  // Virtual delivery store (kept separate - not a physical location for schema)
  window.VIRTUAL_DELIVERY_STORE = {
    id: "3782",
    marketId: "edmonton",
    pickupOnly: false,
    name: "Smokey's Delivery",
    address: "5017 22 Ave SW",
    city: "Edmonton",
    province: "AB",
    postalCode: "T6X 2N4",
    latitude: 53.4137833,
    longitude: -113.4193435,
    isDeliveryAvailable: true,
    isVirtualStore: true,
    deliveryRadius: 50,
    displayRadiusKmDriving: 50,
    openUntil: window.STORE_HOURS.closeTime,
    deliveryHours: { start: 11, end: window.STORE_HOURS.closeHour24 },
    cutoffTime: 45,
    phone: "+17804400911"
  };

  // Load physical stores from Liquid config or use hardcoded fallback
  if (RS_STORE_DATA && RS_STORE_DATA.stores) {
    // Normalize stores from config and add virtual delivery store
    window.STORES = RS_STORE_DATA.stores.map(normalizeStore);
    window.STORES.push(window.VIRTUAL_DELIVERY_STORE);
    window.CAPILANO_STORE = RS_STORE_DATA.stores.find(function(s) { return s.id === "3779"; }) || null;
    if (window.CAPILANO_STORE) {
      window.CAPILANO_STORE = normalizeStore(window.CAPILANO_STORE);
    }
  } else {
    // Fallback: hardcoded stores if Liquid JSON missing
    window.STORES = window.STORES || [
      {
        id: "3782",
        marketId: "edmonton",
        pickupOnly: false,
        name: "Smokey's Walker",
        address: "5017 22 Ave SW",
        city: "Edmonton",
        province: "AB",
        postalCode: "T6X 2N4",
        latitude: 53.4137833,
        longitude: -113.4193435,
        isDeliveryAvailable: false,
        deliveryRadius: 0,
        openUntil: window.STORE_HOURS.closeTime,
        phone: "+17804400911",
        license: "781636"
      },
      window.VIRTUAL_DELIVERY_STORE,
      {
        id: "3781",
        marketId: "edmonton",
        pickupOnly: false,
        name: "Smokey's Mill Creek",
        address: "2366 23 Ave NW",
        city: "Edmonton",
        province: "AB",
        postalCode: "T6T 0R1",
        latitude: 53.45512,
        longitude: -113.37738,
        isDeliveryAvailable: false,
        deliveryRadius: 0,
        openUntil: window.STORE_HOURS.closeTime,
        phone: "+17805402280",
        license: "781797"
      },
      {
        id: "3779",
        marketId: "edmonton",
        pickupOnly: false,
        name: "Smokey's Capilano",
        address: "7223 101 Ave NW",
        city: "Edmonton",
        province: "AB",
        postalCode: "T6A 0H9",
        latitude: 53.5409312,
        longitude: -113.4396412,
        isDeliveryAvailable: false,
        deliveryRadius: 0,
        openUntil: window.STORE_HOURS.closeTime,
        phone: "+17804402912",
        license: "778064"
      },
      {
        id: "3784",
        marketId: "toronto",
        pickupOnly: true,
        name: "Smokey's Beaches",
        address: "1881 Queen Street E",
        city: "Toronto",
        province: "ON",
        postalCode: "M4L 1H4",
        latitude: 43.668706,
        longitude: -79.3055603,
        isDeliveryAvailable: false,
        deliveryRadius: 25,
        openUntil: window.STORE_HOURS.closeTime,
        phone: "+14167924959",
        license: "CRSA1204424"
      }
    ];

    window.CAPILANO_STORE = window.CAPILANO_STORE || {
      id: "3779",
      name: "Smokey's Capilano",
      address: "7223 101 Ave NW",
      city: "Edmonton",
      province: "AB",
      postalCode: "T6A 0H9",
      latitude: 53.5409312,
      longitude: -113.4396412,
      isDeliveryAvailable: false,
      deliveryRadius: 0,
      openUntil: window.STORE_HOURS.closeTime,
      phone: "+17804402912",
      license: "778064"
    };
  }

  // 2. keep legacy identifiers for older snippets
  var CAPILANO_STORE = window.CAPILANO_STORE;
  var STORES = window.STORES;

/* Calculates tonight's closing time - uses centralized config */
function getTodayClosingTime() {
  return window.STORE_HOURS.closeTime;
}
window.getTodayClosingTime = getTodayClosingTime; // Export globally

/* 1️⃣  Add the helper function somewhere near the top */
function ensureCartHasStoreAttribute() {
  var savedStoreId = localStorage.getItem('selectedStoreId');
  if (!savedStoreId) return Promise.resolve(false);

  return fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // Already correct => do nothing
      if (cart.attributes && cart.attributes.store_id === savedStoreId) {
        return false; // No change needed
      }

      // Get the store city (mode-aware lookup for duplicate IDs like 3782 physical/virtual)
      var isDelivery = localStorage.getItem('deliverySelected') === 'true';

      var savedStore = isDelivery
        ? (STORES.find(function(s){ return s.id === savedStoreId && s.isVirtualStore; }) ||
           STORES.find(function(s){ return s.id === savedStoreId && s.isDeliveryAvailable; }) ||
           STORES.find(function(s){ return s.id === savedStoreId; }))
        : (STORES.find(function(s){ return s.id === savedStoreId && !s.isVirtualStore; }) ||
           STORES.find(function(s){ return s.id === savedStoreId; }));

      var savedStoreCity = savedStore ? savedStore.city : ((window.themeSettings && window.themeSettings.default_city) || 'Edmonton');

      // Otherwise patch the cart attribute
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { store_id: savedStoreId, store_city: savedStoreCity } })
      }).then(function() {
        // Restored store_id on new cart
        return true; // Indicate we had to fix it
      });
    })
    .catch(function(err) {
      console.error('[Store‑Locator] Failed to restore store_id:', err);
      return false;
    });
}

/* Check if user already has a store selected */
function hasExistingStoreSelection() {
  return localStorage.getItem('selectedStoreId') !== null;
}

/* Returns current store info + delivery preference (from localStorage) */
function getCurrentStore() {
  var storeId = localStorage.getItem('selectedStoreId');
  if (!storeId) return null;
  
  var isDelivery = localStorage.getItem('deliverySelected') === 'true';
  
  // For stores that share the same ID (physical/virtual pairs), 
  // pick the one that matches the delivery preference
  var store;
  
  if (isDelivery) {
    // Prefer the virtual store when IDs are duplicated (e.g., 3782 physical + 3782 virtual)
    store = STORES.find(function(s) { return s.id === storeId && s.isVirtualStore; }) ||
            STORES.find(function(s) { return s.id === storeId && s.isDeliveryAvailable; }) ||
            null;
  } else {
    // Look for non-virtual stores first
    store = STORES.find(function(s) { return s.id === storeId && !s.isVirtualStore; });
  }
  
  // If no matching store found, fall back to any store with this ID
  if (!store) {
    store = STORES.find(function(s) { return s.id === storeId; }) || CAPILANO_STORE;
  }

  return {
    marketId: store.marketId || deriveMarketId(store),
    store: store,
    isDelivery: isDelivery,
    pickupOnly: !!store.pickupOnly
  };
}
window.getCurrentStore = getCurrentStore; // if you need it globally

/* Opens the store locator modal (if present) */
function openStoreLocator(isAutoOpen) {
  try {
    // Trigger on-demand Google Maps loading (no-op if already loaded)
    if (typeof window.loadGoogleMaps === 'function') window.loadGoogleMaps();

    var modal = document.getElementById('store-locator-modal');
    if (modal) {
      // Show the modal
      modal.style.display = 'flex';

      // Handle auto-open vs manual open differently
      if (isAutoOpen) {
        // Auto-opening: Add class for tracking AND lock body scroll
        modal.classList.add('auto-opened');
        document.body.classList.add('noscroll');
        if (typeof window.__lockBody === 'function') {
          window.__lockBody();
        }
      } else {
        // Manual open: Remove auto-opened class and lock body scroll
        modal.classList.remove('auto-opened');
        document.body.classList.add('noscroll');
        if (typeof window.__lockBody === 'function') {
          window.__lockBody();
        }
      }

      // Run init if available
      if (typeof window.initLocator === 'function') {
        window.initLocator();
      }
    } else {
      // fallback if snippet not found
      console.error('[Store-Locator] Modal element not found');
      window.location.href = '/';
    }
  } catch (error) {
    console.error('[Store-Locator] Error opening store locator:', error);
  }
}

// Make it globally available for other scripts
window.openStoreLocator = openStoreLocator;

// Also expose finalizeStoreSelection globally
window.finalizeStoreSelection = finalizeStoreSelection;

/*
  finalizeStoreSelection(storeId, mode)
  Refactored: extracted helpers, mode switch detection, express variant removal,
  correct event dispatch timing (AFTER cart update), reload loop guard.
*/
function finalizeStoreSelection(storeId, mode) {
  window.finalizeStoreSelection = finalizeStoreSelection; // Keep globally available

  // Previous state
  var oldStoreId = localStorage.getItem('selectedStoreId');
  var oldMode = localStorage.getItem('deliverySelected') === 'true' ? 'delivery' : 'pickup';

  // Detect context switches
  var isSwitchingStores = oldStoreId && oldStoreId !== storeId;
  var isSwitchingMode = oldStoreId === storeId && oldMode !== mode;

  // Mode-aware store lookup (handles duplicate IDs for physical/virtual stores)
  function getSelectedStore(id, selectedMode) {
    if (selectedMode === 'delivery') {
      return STORES.find(function(s) { return s.id === id && s.isVirtualStore; }) ||
             STORES.find(function(s) { return s.id === id && s.isDeliveryAvailable; }) ||
             STORES.find(function(s) { return s.id === id; });
    } else {
      return STORES.find(function(s) { return s.id === id && !s.isVirtualStore; })
             || STORES.find(function(s) { return s.id === id; });
    }
  }

  // Helper: remove express variants from cart on pickup switch
  function removeExpressVariants() {
    return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      // Collect all express variant IDs from globals
      function collectIds(root) {
        var out = [];
        function walk(x) {
          if (x == null) return;
          var t = typeof x;
          if (t === 'number' || t === 'string') { out.push(x); return; }
          if (Object.prototype.toString.call(x) === '[object Array]') {
            for (var i = 0; i < x.length; i++) walk(x[i]);
            return;
          }
          if (t === 'object') {
            for (var k in x) {
              if (Object.prototype.hasOwnProperty.call(x, k)) walk(x[k]);
            }
          }
        }
        walk(root);
        return out;
      }

      var allExpressVariants = collectIds(window.EXPRESS_VARIANTS)
        .concat(collectIds(window.EXPRESS_VARIANTS_BY_STORE));

      var items = cart && cart.items ? cart.items : [];
      var updates = {};
      for (var i = 0; i < items.length; i++) {
        var vid = items[i] && items[i].variant_id;
        for (var j = 0; j < allExpressVariants.length; j++) {
          if (String(allExpressVariants[j]) === String(vid)) {
            updates[vid] = 0;
            break;
          }
        }
      }

      if (Object.keys(updates).length === 0) return Promise.resolve();

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }).catch(function(e) {
      console.error('[Store-Locator] Failed to remove express variants:', e);
    });
  }

  // Helper: update cart attributes and optionally clear note
  function updateCart(cartAttributes, clearNote) {
    var body = { attributes: cartAttributes };
    if (clearNote) body.note = '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  // Helper: close modal
  function closeModal() {
    var modal = document.getElementById('store-locator-modal');
    if (modal) {
      modal.style.display = 'none';
      modal.classList.remove('auto-opened');
      if (typeof window.__unlockBody === 'function') {
        window.__unlockBody();
      } else {
        document.body.classList.remove('noscroll');
      }
    }
  }

  // Helper: dispatch events (MUST run AFTER cart update to avoid race conditions)
  function dispatchEvents() {
    window.dispatchEvent(new Event('storeSelected'));
    window.dispatchEvent(new CustomEvent('deliveryModeChanged', {
      detail: { mode: mode }
    }));
  }

  // Helper: set localStorage + cookie
  function setLocalState() {
    localStorage.setItem('selectedStoreId', storeId);
    localStorage.setItem('deliverySelected', (mode === 'delivery').toString());
    document.cookie = 'store_id=' + storeId + '; path=/; max-age=86400';
  }

  // Build cart attributes
  var selectedStore = getSelectedStore(storeId, mode);
  var storeCity = selectedStore ? selectedStore.city : ((window.themeSettings && window.themeSettings.default_city) || 'Edmonton');
  var cartAttributes = { store_id: storeId, store_city: storeCity };

  // Clear delivery attributes when switching to pickup (use '' not null for Shopify)
  if (mode === 'pickup') {
    cartAttributes['Delivery Date'] = '';
    cartAttributes['Delivery Time'] = '';
    cartAttributes['Delivery Window'] = '';
    cartAttributes['_delivery_slot_id'] = '';
    cartAttributes['Express Delivery'] = '';
    cartAttributes['Express Delivery ETA'] = '';
    cartAttributes['Express Delivery Price'] = '';
  }

  // Reload loop prevention
  var reloadKey = 'store_locator_just_reloaded';
  function safeReload() {
    // Always reload on user-initiated store switch.
    // Only set the key to avoid accidental double-reload on the immediate next load.
    sessionStorage.setItem(reloadKey, 'true');
    setTimeout(function() { location.reload(); }, 100);
  }

  if (isSwitchingStores) {
    // Switching stores: clear entire cart, then set state
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function() {
        setLocalState();
        closeModal();
        return updateCart(cartAttributes, mode === 'pickup');
      })
      .then(function() {
        dispatchEvents();
        safeReload();
      })
      .catch(function(error) {
        console.error('[Store-Locator] Error clearing cart:', error);
        safeReload();
      });

  } else if (isSwitchingMode && mode === 'pickup') {
    // Switching to pickup (same store): remove express variants + clear delivery attrs
    setLocalState();
    closeModal();
    removeExpressVariants()
      .then(function() { return updateCart(cartAttributes, true); })
      .then(function() {
        dispatchEvents();
        safeReload();
      })
      .catch(function(error) {
        console.error('[Store-Locator] Error switching to pickup:', error);
        safeReload();
      });

  } else {
    // Same store + same mode, OR switching to delivery, OR first selection
    setLocalState();
    closeModal();
    updateCart(cartAttributes, mode === 'pickup')
      .then(function() {
        dispatchEvents();
        safeReload();
      })
      .catch(function(error) {
        console.error('[Store-Locator] Error updating cart:', error);
        safeReload();
      });
  }
}

// ========= DELIVERY CONFIG (Multi-Market) =========
// Single source of truth for all delivery calculations.
// Ported from ExcuzeMoi, adapted to Smokey's hubs/stores.
// Usage: var quote = window.SMOKEYS_DELIVERY.getQuote();
(function() {

  var DELIVERY_CONFIG = {
    etaSafetyPadding: 1.25,

    // Hub definitions: storeId → market + coordinates
    hubs: {
      '3782': { marketId: 'edmonton', name: 'Walker Hub',  lat: 53.4137833, lng: -113.4193435 },
      '3784': { marketId: 'toronto',  name: 'Beaches Hub', lat: 43.668706,  lng: -79.3055603  }
    },

    markets: {
      edmonton: {
        pickupOnly: false,
        freeThresholdCents: 5000,
        maxDeliveryKm: 35,
        expressMaxKm: 50,
        timeZone: 'America/Edmonton',
        hours: {
          default: { open: 600, close: 1380 },
          exceptions: {}
        },
        cutoffs: {
          expressMinutesBefore: 90,
          standardMinutesBefore: 90
        },
        hub: {
          id: '3782',
          name: 'Smokey\'s Walker Hub',
          lat: 53.4137833,
          lng: -113.4193435
        },
        tiers: [
          { maxKm: 7,  standardFee: 4.99, minOrderCents: 1999, etaExpressMin: 10, etaExpressMax: 20, etaStandardMin: 45, etaStandardMax: 60 },
          { maxKm: 11, standardFee: 4.99, minOrderCents: 2499, etaExpressMin: 12, etaExpressMax: 25, etaStandardMin: 50, etaStandardMax: 70 },
          { maxKm: 18, standardFee: 7.99, minOrderCents: 3999, etaExpressMin: 15, etaExpressMax: 30, etaStandardMin: 55, etaStandardMax: 80 },
          { maxKm: 25, standardFee: 9.99, minOrderCents: 5999, etaExpressMin: 20, etaExpressMax: 35, etaStandardMin: 60, etaStandardMax: 90 },
          { maxKm: 35, standardFee: 9.99, minOrderCents: 7999, etaExpressMin: 25, etaExpressMax: 45, etaStandardMin: 70, etaStandardMax: 105 }
        ],
        zones: {
          'sherwood-park':  { label: 'Sherwood Park',     centroid: { lat: 53.5450, lng: -113.3125 } },
          'beaumont':       { label: 'Beaumont',          centroid: { lat: 53.3572, lng: -113.4122 } },
          'leduc':          { label: 'Leduc & Nisku',     centroid: { lat: 53.2594, lng: -113.5519 } },
          'u-of-a':         { label: 'U of A Campus',     centroid: { lat: 53.5232, lng: -113.5263 } },
          'macewan':        { label: 'MacEwan Campus',    centroid: { lat: 53.5470, lng: -113.5000 } },
          'downtown':       { label: 'Downtown Edmonton', centroid: { lat: 53.5461, lng: -113.4938 } },
          'south-edmonton': { label: 'South Edmonton',    centroid: { lat: 53.4500, lng: -113.4800 } },
          'west-edmonton':  { label: 'West Edmonton',     centroid: { lat: 53.5220, lng: -113.6250 } },
          'north-edmonton': { label: 'North Edmonton',    centroid: { lat: 53.6100, lng: -113.5000 } },
          'whyte-ave':      { label: 'Whyte Ave',         centroid: { lat: 53.5183, lng: -113.4970 } },
          'windermere':     { label: 'Windermere & SW',   centroid: { lat: 53.4360, lng: -113.6030 } }
        }
      },
      toronto: {
        pickupOnly: true,
        timeZone: 'America/Toronto',
        hours: {
          default: { open: 600, close: 1380 },
          exceptions: {}
        },
        hub: {
          id: '3784',
          name: 'Smokey\'s Beaches',
          lat: 43.668706,
          lng: -79.3055603
        },
        zones: {
          'beaches': { label: 'The Beaches', centroid: { lat: 43.668706, lng: -79.3055603 } }
        }
      }
    }
  };

  // --- Utility functions ---

  function haversineKm(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function getTierForKm(km, marketId) {
    var market = DELIVERY_CONFIG.markets[marketId || 'edmonton'];
    if (!market || !market.tiers) return null;
    for (var i = 0; i < market.tiers.length; i++) {
      if (km <= market.tiers[i].maxKm) return market.tiers[i];
    }
    return null;
  }

  function getExpressFeeForKm(km) {
    if (km <= 10) return 4.99;
    if (km <= 20) return 6.99;
    if (km <= 30) return 8.99;
    if (km <= 50) return 12.99;
    return null;
  }

  function deliveryFormatMoney(amount) {
    return '$' + Number(amount).toFixed(2);
  }

  // Straight-line distance (matches Shopify Local Delivery)
  function getShopifyKm(userLat, userLng, storeLat, storeLng) {
    return haversineKm(userLat, userLng, storeLat, storeLng);
  }

  // Driving distance: cached Google result or haversine × 1.5 fallback
  function getExpressKm(storeId, userLat, userLng, storeLat, storeLng) {
    var key = 'kmDriving:' + storeId + ':' + userLat.toFixed(5) + ',' + userLng.toFixed(5);
    var cached = parseFloat(sessionStorage.getItem(key));
    if (isFinite(cached) && cached > 0) return cached;
    return haversineKm(userLat, userLng, storeLat, storeLng) * 1.5;
  }

  function getUserPosition() {
    try {
      var saved = sessionStorage.getItem('userPosition');
      if (!saved) {
        var last = localStorage.getItem('lastUserPosition');
        var lastTs = parseInt(localStorage.getItem('lastUserPosition_ts') || '0', 10);
        var MAX_AGE = 30 * 24 * 60 * 60 * 1000;
        if (last && lastTs && (Date.now() - lastTs) < MAX_AGE) {
          saved = last;
          try { sessionStorage.setItem('userPosition', last); } catch (e) {}
        }
      }
      if (!saved) return null;
      var pos = JSON.parse(saved);
      return { lat: pos.lat || pos.latitude, lng: pos.lng || pos.longitude };
    } catch (e) {
      return null;
    }
  }

  function getStoreInfo() {
    if (typeof window.getCurrentStore !== 'function') return null;
    return window.getCurrentStore();
  }

  function getActiveMarket() {
    var current = getStoreInfo();
    var marketId = (current && current.marketId) ? current.marketId : 'edmonton';
    var market = DELIVERY_CONFIG.markets[marketId] || null;
    return { marketId: marketId, market: market, current: current };
  }

  // --- Hub resolution ---

  function getSelectedHubId() {
    var id = localStorage.getItem('selectedStoreId');
    return id || null;
  }

  function getMarketIdForHub(hubId) {
    if (DELIVERY_CONFIG.hubs[hubId]) return DELIVERY_CONFIG.hubs[hubId].marketId;
    if (window.SMOKEYS_DELIVERY && window.SMOKEYS_DELIVERY._debug) {
      console.warn('[DELIVERY] Unknown hubId:', hubId, '— defaulting to edmonton');
    }
    return 'edmonton';
  }

  function getCurrentMarketId() {
    var hubId = getSelectedHubId();
    if (!hubId) return 'edmonton';
    return getMarketIdForHub(hubId);
  }

  function getMaxDeliveryKm(marketId) {
    var market = DELIVERY_CONFIG.markets[marketId || getCurrentMarketId()];
    return (market && market.maxDeliveryKm) ? market.maxDeliveryKm : 35;
  }

  function getHubCoords(marketId) {
    var market = DELIVERY_CONFIG.markets[marketId || getCurrentMarketId()];
    if (market && market.hub) return { lat: market.hub.lat, lng: market.hub.lng };
    // Fallback: Walker hub
    return { lat: 53.4137833, lng: -113.4193435 };
  }

  // --- Main quote calculation ---

  function getQuote() {
    var active = getActiveMarket();
    var marketId = active.marketId;
    var market = active.market;
    var current = active.current;

    if (!market || !(current && current.store)) return null;

    if (market.pickupOnly || current.pickupOnly || !current.isDelivery) {
      return {
        marketId: marketId,
        pickupOnly: true,
        isDelivery: false,
        storeId: current.store.id,
        store: current.store,
        calculatedAt: Date.now()
      };
    }

    var userPos = getUserPosition();
    if (!userPos || !userPos.lat || !userPos.lng) return null;

    var storeLat = current.store.latitude;
    var storeLng = current.store.longitude;
    var storeId = current.store.id || 'unknown';

    var shopifyKm = getShopifyKm(userPos.lat, userPos.lng, storeLat, storeLng);
    var expressKm = getExpressKm(storeId, userPos.lat, userPos.lng, storeLat, storeLng);
    var inRange = shopifyKm <= market.maxDeliveryKm;

    if (!inRange) {
      return {
        marketId: marketId, pickupOnly: false, isDelivery: true, inRange: false,
        expressAvailable: false, storeId: storeId, store: current.store,
        userLat: userPos.lat, userLng: userPos.lng, storeLat: storeLat, storeLng: storeLng,
        km: shopifyKm, shopifyKm: shopifyKm, expressKm: expressKm, calculatedAt: Date.now()
      };
    }

    var tier = getTierForKm(shopifyKm, marketId);
    if (!tier) {
      var tiers = market.tiers;
      tier = (tiers && tiers.length) ? tiers[tiers.length - 1] : null;
    }
    if (!tier) return null;

    var expressAvailable = expressKm <= market.expressMaxKm;
    var expressFee = expressAvailable ? getExpressFeeForKm(expressKm) : null;

    return {
      marketId: marketId, pickupOnly: false, isDelivery: true,
      storeId: storeId, store: current.store,
      userLat: userPos.lat, userLng: userPos.lng, storeLat: storeLat, storeLng: storeLng,
      km: shopifyKm, shopifyKm: shopifyKm, expressKm: expressKm,
      inRange: true, expressAvailable: expressAvailable,
      expressFee: expressFee, standardFee: tier.standardFee,
      freeThreshold: market.freeThresholdCents / 100,
      freeThresholdCents: market.freeThresholdCents,
      minOrderCents: tier.minOrderCents, minOrder: tier.minOrderCents / 100,
      etaExpressMin: tier.etaExpressMin, etaExpressMax: tier.etaExpressMax,
      etaStandardMin: tier.etaStandardMin, etaStandardMax: tier.etaStandardMax,
      expressFeeFormatted: expressFee != null ? deliveryFormatMoney(expressFee) : 'Not available',
      standardFeeFormatted: deliveryFormatMoney(tier.standardFee),
      minOrderFormatted: deliveryFormatMoney(tier.minOrderCents / 100),
      expressEtaFormatted: expressAvailable ? tier.etaExpressMin + '-' + tier.etaExpressMax + ' min' : 'Not available',
      standardEtaFormatted: tier.etaStandardMin + '-' + tier.etaStandardMax + ' min',
      tierMaxKm: tier.maxKm, calculatedAt: Date.now()
    };
  }

  function updateQuote() {
    var quote = getQuote();
    if (quote) {
      sessionStorage.setItem('deliveryQuote', JSON.stringify(quote));
      window.dispatchEvent(new CustomEvent('deliveryQuoteChanged', { detail: quote }));
    }
    return quote;
  }

  function getCachedQuote() {
    try {
      var saved = sessionStorage.getItem('deliveryQuote');
      return saved ? JSON.parse(saved) : null;
    } catch (e) { return null; }
  }

  // --- Zone quote (hub → zone centroid, for zone cards / data-dyn zone-lock) ---

  function getZoneDefaults(zoneId, marketId) {
    var mktId = marketId || getActiveMarket().marketId || 'edmonton';
    var market = DELIVERY_CONFIG.markets[mktId];
    if (!market || !market.zones) return null;
    return market.zones[zoneId] || null;
  }

  function getZoneQuote(zoneId, marketId) {
    var active = getActiveMarket();
    var mktId = marketId || active.marketId || 'edmonton';
    var market = DELIVERY_CONFIG.markets[mktId];
    var current = active.current;
    if (!market || !market.zones) return null;

    var hubLat = null, hubLng = null, hubId = null;

    if (current && current.store && current.marketId === mktId &&
        typeof current.store.latitude === 'number' && typeof current.store.longitude === 'number') {
      hubLat = current.store.latitude;
      hubLng = current.store.longitude;
      hubId = String(current.store.id);
    } else if (market.hub && typeof market.hub.lat === 'number') {
      hubLat = market.hub.lat;
      hubLng = market.hub.lng;
      hubId = String(market.hub.id || 'default');
    }

    if (hubLat == null || hubLng == null || !hubId) return null;

    var zone = market.zones[zoneId];
    if (!zone || !zone.centroid) return null;

    var shopifyKm = haversineKm(hubLat, hubLng, zone.centroid.lat, zone.centroid.lng);

    // Check for cached driving km
    var drivingKm = null;
    var cacheKey = 'zoneDrivingKm:' + mktId + ':' + hubId + ':' + zoneId;
    try {
      var cachedStr = localStorage.getItem(cacheKey);
      if (cachedStr) {
        var cached = JSON.parse(cachedStr);
        if (cached && cached.ts && (Date.now() - cached.ts < 7 * 24 * 60 * 60 * 1000)) {
          drivingKm = cached.km;
        }
      }
    } catch (e) {}
    if (drivingKm === null) drivingKm = shopifyKm * 1.5;

    var tier = getTierForKm(shopifyKm, mktId);
    if (!tier) {
      var tiers = market.tiers;
      tier = (tiers && tiers.length) ? tiers[tiers.length - 1] : null;
    }
    if (!tier) return null;

    var expressMaxKm = market.expressMaxKm || 50;
    var expressAvail = drivingKm <= expressMaxKm;
    var expressFee = expressAvail ? getExpressFeeForKm(drivingKm) : null;

    return {
      zoneId: zoneId, marketId: mktId, hubStoreId: hubId,
      label: zone.label || zoneId,
      shopifyKm: shopifyKm, drivingKm: drivingKm,
      standardFee: tier.standardFee,
      standardFeeFormatted: deliveryFormatMoney(tier.standardFee),
      expressFee: expressFee,
      expressFeeFormatted: expressFee != null ? deliveryFormatMoney(expressFee) : 'Not available',
      expressEta: tier.etaExpressMin + '-' + tier.etaExpressMax + ' min',
      standardEta: tier.etaStandardMin + '-' + tier.etaStandardMax + ' min',
      freeThreshold: market.freeThresholdCents / 100,
      freeThresholdFormatted: deliveryFormatMoney(market.freeThresholdCents / 100),
      minOrder: tier.minOrderCents,
      minOrderFormatted: deliveryFormatMoney(tier.minOrderCents / 100),
      expressAvailable: expressAvail,
      calculatedAt: Date.now()
    };
  }

  // Prefetch driving distances for zone cards (uses Google DistanceMatrix when available)
  function prefetchZoneDrivingKm(marketId, zoneIds) {
    var mktId = marketId || 'edmonton';
    var market = DELIVERY_CONFIG.markets[mktId];
    if (!market || !market.zones) return;

    var hubLat = null, hubLng = null, hubId = null;
    if (typeof window.getCurrentStore === 'function') {
      var cur = window.getCurrentStore();
      if (cur && cur.marketId === mktId && cur.store &&
          typeof cur.store.latitude === 'number' && typeof cur.store.longitude === 'number') {
        hubLat = cur.store.latitude;
        hubLng = cur.store.longitude;
        hubId = String(cur.store.id);
      }
    }
    if (hubLat == null && market.hub) {
      hubLat = market.hub.lat;
      hubLng = market.hub.lng;
      hubId = String(market.hub.id || 'default');
    }
    if (hubLat == null || hubLng == null || !hubId) return;

    var allZoneIds = zoneIds || Object.keys(market.zones);
    var zonesToFetch = [];
    for (var i = 0; i < allZoneIds.length; i++) {
      var zid = allZoneIds[i];
      var z = market.zones[zid];
      if (!z || !z.centroid) continue;
      var ck = 'zoneDrivingKm:' + mktId + ':' + hubId + ':' + zid;
      try {
        var cs = localStorage.getItem(ck);
        if (cs) {
          var cv = JSON.parse(cs);
          if (cv && cv.ts && (Date.now() - cv.ts < 7 * 24 * 60 * 60 * 1000)) continue;
        }
      } catch (e) {}
      zonesToFetch.push({ id: zid, zone: z });
    }
    if (zonesToFetch.length === 0) return;

    // If no Google Maps, use estimates
    if (!window.google || !window.google.maps || !window.google.maps.DistanceMatrixService) {
      for (var j = 0; j < zonesToFetch.length; j++) {
        var est = haversineKm(hubLat, hubLng, zonesToFetch[j].zone.centroid.lat, zonesToFetch[j].zone.centroid.lng) * 1.5;
        var eKey = 'zoneDrivingKm:' + mktId + ':' + hubId + ':' + zonesToFetch[j].id;
        try { localStorage.setItem(eKey, JSON.stringify({ km: est, ts: Date.now(), estimated: true, hubId: hubId })); } catch (e) {}
      }
      return;
    }

    var destinations = [];
    for (var d = 0; d < zonesToFetch.length; d++) {
      destinations.push(new google.maps.LatLng(zonesToFetch[d].zone.centroid.lat, zonesToFetch[d].zone.centroid.lng));
    }

    var service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix({
      origins: [new google.maps.LatLng(hubLat, hubLng)],
      destinations: destinations,
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.METRIC
    }, function(response, status) {
      var elements = (status === 'OK' && response && response.rows && response.rows[0]) ? response.rows[0].elements : null;
      for (var r = 0; r < zonesToFetch.length; r++) {
        var rKey = 'zoneDrivingKm:' + mktId + ':' + hubId + ':' + zonesToFetch[r].id;
        var km, estimated;
        if (elements && elements[r] && elements[r].status === 'OK' && elements[r].distance) {
          km = elements[r].distance.value / 1000;
          estimated = false;
        } else {
          km = haversineKm(hubLat, hubLng, zonesToFetch[r].zone.centroid.lat, zonesToFetch[r].zone.centroid.lng) * 1.5;
          estimated = true;
        }
        try { localStorage.setItem(rKey, JSON.stringify({ km: km, ts: Date.now(), estimated: estimated, hubId: hubId })); } catch (e) {}
      }
      window.dispatchEvent(new Event('zoneDrivingKmCached'));
    });
  }

  function isPickupOnlyMarket() {
    var result = getActiveMarket();
    return !!((result.market && result.market.pickupOnly) || (result.current && result.current.pickupOnly));
  }

  function getMarketConfig(marketId) {
    return DELIVERY_CONFIG.markets[marketId] || null;
  }

  // ----- Legacy globals sync (single source: DELIVERY_CONFIG) -----
  // Keeps cart-delivery.js + other older code working without duplicating config.
  // Safe for pickup-only markets (Toronto etc.) — zeros out globals so old code won't crash.
  function syncLegacyDeliveryGlobals() {
    try {
      var marketId = (typeof getCurrentMarketId === 'function' && getCurrentMarketId()) || 'edmonton';
      var market = (DELIVERY_CONFIG.markets && DELIVERY_CONFIG.markets[marketId]) || DELIVERY_CONFIG.markets.edmonton;
      if (!market) return;

      // Pickup-only markets have no delivery tiers/threshold — zero out legacy globals
      if (market.pickupOnly || !Array.isArray(market.tiers) || !market.tiers.length) {
        window.FREE_DELIVERY_THRESHOLD = 0;
        window.DELIVERY_ZONES = [];
        return;
      }

      // Threshold (cents)
      window.FREE_DELIVERY_THRESHOLD = (typeof market.freeThresholdCents === 'number')
        ? market.freeThresholdCents
        : 0;

      // Zones (Shopify-style tiers used by cart-delivery.js)
      window.DELIVERY_ZONES = market.tiers.map(function(t) {
        return {
          maxKm: t.maxKm,
          minOrderCents: t.minOrderCents,
          deliveryFeeCents: Math.round((t.standardFee || 0) * 100)
        };
      });
    } catch (e) {
      // never block
    }
  }
  window.syncLegacyDeliveryGlobals = syncLegacyDeliveryGlobals;

  // --- Expose global API ---

  window.SMOKEYS_DELIVERY = {
    CONFIG: DELIVERY_CONFIG,
    getQuote: getQuote,
    updateQuote: updateQuote,
    getCachedQuote: getCachedQuote,
    getZoneDefaults: getZoneDefaults,
    getZoneQuote: getZoneQuote,
    prefetchZoneDrivingKm: prefetchZoneDrivingKm,
    getActiveMarket: getActiveMarket,
    getCurrentMarketId: getCurrentMarketId,
    getMarketConfig: getMarketConfig,
    getMaxDeliveryKm: getMaxDeliveryKm,
    getHubCoords: getHubCoords,
    isPickupOnlyMarket: isPickupOnlyMarket,
    getSelectedHubId: getSelectedHubId,
    getMarketIdForHub: getMarketIdForHub,
    getShopifyKm: getShopifyKm,
    getExpressKm: getExpressKm,
    getTierForKm: getTierForKm,
    getExpressFeeForKm: getExpressFeeForKm,
    haversineKm: haversineKm,
    formatMoney: deliveryFormatMoney,
    getUserPosition: getUserPosition,
    getStoreInfo: getStoreInfo,
    _debug: false
  };

  // Backward compatibility
  window.getExpressPriceForDistance = function(km) {
    return getExpressFeeForKm(km);
  };

  // Initial legacy globals sync once config is ready
  syncLegacyDeliveryGlobals();

  // Event listeners: auto-update quote on position/store/mode changes
  function setupDeliveryListeners() {
    window.addEventListener('userPositionChanged', function() { updateQuote(); });
    window.addEventListener('storeSelected', function() { updateQuote(); syncLegacyDeliveryGlobals(); });
    window.addEventListener('deliveryModeChanged', function() { updateQuote(); syncLegacyDeliveryGlobals(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDeliveryListeners);
  } else {
    setupDeliveryListeners();
  }

  // Initial quote if position already exists
  setTimeout(function() {
    var existingQuote = getQuote();
    if (existingQuote) {
      sessionStorage.setItem('deliveryQuote', JSON.stringify(existingQuote));
    }
  }, 100);

})();
// ========= END DELIVERY CONFIG =========

/*
  On page load => if no store chosen, auto-open the modal
  so user must pick a store first
*/
document.addEventListener('DOMContentLoaded', function() {
  // Clear store-switch reload key so next switch can reload again
  sessionStorage.removeItem('store_locator_just_reloaded');

  // Check if age gate exists on the page
  var ageGateExists = document.getElementById('age-gate-modal') !== null;

  if (ageGateExists) {
    // Check if user has verified age
    var ageVerified = localStorage.getItem('smokeys_age_verified') === 'true' ||
                        document.cookie.includes('smokeys_age_verified=true');

    if (!ageVerified) {
      // Waiting for age verification first

      // Set up one-time listener for age verification
      var ageVerifiedHandler = function() {
        window.removeEventListener('ageVerified', ageVerifiedHandler);
        if (!hasExistingStoreSelection()) {
          // Small delay to ensure age gate is fully closed
          setTimeout(function() { openStoreLocator(true); }, 300);
        }
      };

      window.addEventListener('ageVerified', ageVerifiedHandler);

      // Fallback: If age gate doesn't trigger within 10 seconds, proceed anyway
      setTimeout(function() {
        window.removeEventListener('ageVerified', ageVerifiedHandler);
        var ageModal = document.getElementById('age-gate-modal');
        if (!hasExistingStoreSelection() && (!ageModal || ageModal.style.display !== 'flex')) {
          // Age gate timeout - proceeding with store selection
          openStoreLocator(true);
        }
      }, 10000);

      return;
    }
  }

  // If no age gate or already verified, proceed normally
  if (!hasExistingStoreSelection()) {
    openStoreLocator(true);
    return;
  }

  // Otherwise, silently fix the new cart if needed
  // Guard: only one store-attribute reload per session to prevent double-boot
  if (sessionStorage.getItem('smokeys_store_attr_reloaded')) {
    sessionStorage.removeItem('smokeys_store_attr_reloaded');
    // Already reloaded once — still ensure attribute is set but don't reload again
    ensureCartHasStoreAttribute();
    return;
  }

  ensureCartHasStoreAttribute().then(function(didFix) {
    if (didFix) {
      sessionStorage.setItem('smokeys_store_attr_reloaded', '1');
      location.reload();
    }
  });
});

} // End of singleton pattern
